/**
 * Organization API
 * Routes through APISIX to auth-service: /v1/users/me/organizations
 * and /v1/users/me/switch-organization.
 */

import { apiClient } from './api-client'

export interface UserOrganization {
  id: string
  name: string
  domain?: string
}

interface OrganizationsListResponse {
  organizations: UserOrganization[]
}

export const organizationApi = {
  async listUserOrganizations(): Promise<UserOrganization[]> {
    const res = await apiClient.get<OrganizationsListResponse>('/v1/users/me/organizations')
    return res.organizations ?? []
  },

  // auth-service reads organization_id and answers 400 without it; chat's API
  // client sends bodies as written, unlike the console's, which converts keys.
  async switchOrganization(organizationId: string): Promise<void> {
    await apiClient.post<void>('/v1/users/me/switch-organization', { organization_id: organizationId })
  },
}
